import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { BrandEffects } from "./+state/effects";
import { BrandFacade } from "./+state/facades";
import { BrandService } from "./+state/services";
import { brandStore, BRAND_STORE } from "./+state/store";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([BrandEffects]),
    StoreModule.forFeature(BRAND_STORE, brandStore)
  ],
  providers: [BrandFacade, BrandService]
})
export class BrandDataAccessModule {}
